import * as React from 'react';

import { Text } from '../Text';
import { ISimpleInputProps } from '../SimpleInput';
import { InputM } from './InputM';

import { mergeStyles } from '@cian/utils';
import * as styles from './InputsMultiple.css';

export interface IInputsMultipleProps extends React.HTMLProps<HTMLInputElement> {
  label: string;
  insideLabel?: string;
  stack: ISimpleInputProps[];
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void;
}

export class InputsMultiple extends React.PureComponent<IInputsMultipleProps> {
  public render() {
    const { stack, label } = this.props;

    return (
      <div
        {...mergeStyles([
          styles['field'],
        ])}
      >
        <div className={styles['label']}>
          <Text
            fontSize={14}
            lineHeight={18}
          >
            {label}
          </Text>
        </div>
        <div className={styles['stack']}>
          {
            stack
              .map((props: ISimpleInputProps, index) =>
                <InputM
                  key={index}
                  disabled={this.props.disabled}
                  type={this.props.type || 'text'}
                  index={index}
                  stackLength={stack.length}
                  {...props}
                  ref={''}
                />,
              )
          }
        </div>
      </div>
    );
  }
}
